import React from "react";

const ChecklistSubtitle = ({ subtitle, totalSelected }) => (
  <h3
    aria-label={`${subtitle}`}
    className={`${
      subtitle === "You can select up to 10 interest areas." && totalSelected > 10 ? "red" : ""
    } checklist-subtitle`}
  >
    {subtitle}{" "}
    {totalSelected >= 0 && (
      <span
        className={`${
          subtitle === "You can select up to 10 interest areas." && totalSelected > 10 ? "red" : ""
        } checklist-subtitle`}
      >
        {subtitle === "You can select up to 10 interest areas."
          ? `(${totalSelected}/10 selected)`
          : `(${totalSelected} selected)`}
      </span>
    )}
  </h3>
);

export default ChecklistSubtitle;
